import { render } from "./Page7.vue?vue&type=template&id=66a0a8fd&scoped=true"
import script from "./Page7.vue?vue&type=script&lang=js"
export * from "./Page7.vue?vue&type=script&lang=js"

import "./Page7.vue?vue&type=style&index=0&id=66a0a8fd&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66a0a8fd"]])

export default __exports__